<template>
  <div class="vertical-socials">
    <div class="vertical-socials__logo">
      <img
        src="~/assets/img/logo/black-signature.svg"
        alt="mia-sofia"
        loading="lazy"
        decoding="async"
      />
    </div>
    <div class="vertical-socials__main-content">
      <span class="vertical-socials__title h3">Присоединяйтесь<br/> к нашему сообществу</span>
      <div class="vertical-socials__socials-list">
        <div
          v-for="(social, index) in socialsList"
          :key="`vertical-socials-list-item-${index}`"
          class="vertical-socials__socials-list-item"
        >
          <a
            :href="social?.link ? social?.link : ''"
            rel="nofollow noopener noreferrer"
          >
            <img
              v-if="social?.logo"
              :src="social?.logo"
              loading="lazy"
              decoding="async"
              :alt="social?.title ? `${social?.title}` : 'social logo'"
            />
          </a>
        </div>
      </div>
    </div>
    <span class="vertical-socials__additional-message">
      Оставайтесь рядом — вместе сделаем<br/>детскую комнату ещё уютнее
    </span>
  </div>
</template>

<script setup lang="ts">
import vkontakteLogo from '~/assets/img/svg/social-media/vk.svg'
import dzenLogo from '~/assets/img/svg/social-media/dzen.svg'
import telegramLogo from '~/assets/img/svg/social-media/telegram.svg'
import pinterestLogo from '~/assets/img/svg/social-media/pinterest-icon.svg'
import { appConfigStore } from '#sitis/stores/modules/app-store';
import {computed} from "#imports";

const appConfig = appConfigStore();

const socialsList = computed(() => {
  return [
    {
      title: 'vkontakte',
      logo: vkontakteLogo,
      link: linkVk.value
    },
    {
      title: 'dzen',
      logo: dzenLogo,
      link: linkDzen.value
    },
    {
      title: 'telegram',
      logo: telegramLogo,
      link: linkTelegram.value
    },
    {
      title: 'pinterest',
      logo: pinterestLogo,
      link: linkPinterest.value
    },
  ]
})
const linkVk = computed(() => appConfig?.config?.vkontakte || '');
const linkTelegram = computed(() => appConfig?.config?.telegram || appConfig?.vars?.Telegram || '');
const linkDzen = computed(() => appConfig?.config?.facebook || '');
const linkPinterest = computed(() => appConfig?.config?.odnoklassniki || '');
</script>

<style scoped lang="scss">
.vertical-socials {
  background-color: white;
  border-radius: 20px;
  padding: 24px 54px;
  height: 100%;
  box-shadow: 13.33px 9px 53.5px 1px #0000000F;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.vertical-socials__logo {
  max-width: 235px;
  max-height: 58px;
}
.vertical-socials__main-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 21px;
  padding-top: 49px;
}
.vertical-socials__title {
  color: var(--text-color-text);
  text-align: center;
  font-weight: 600;
}
.vertical-socials__socials-list {
  display: flex;
  flex-direction: row;
  gap: 13px;
  align-items: center;
  & > * {
    width: 52px;
    height: 52px;
  }
}
.vertical-socials__socials-list-item {
  width: 52px;
  height: 52px;
  background-color: var(--secondary-dark);
  border-radius: 11px;
  transition: background 0.1s linear;
  cursor: pointer;
  a {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  & img {
    filter: invert(98%) sepia(6%) saturate(154%) hue-rotate(227deg) brightness(113%) contrast(100%);
    width: 38px;
    height: 38px;
  }
  &:hover {
    background: #2f2e2e;
  }
}
.vertical-socials__additional-message {
  padding-top: 42px;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0;
  text-align: center;
  color: var(--light-grey)
}
@media screen and (max-width: 1750px) {
  .vertical-socials {
    padding: 24px 48px;
  }
}
@media screen and (max-width: 1240px) {
  .vertical-socials__main-content {
    padding-top: 0;
    margin-top: auto;
  }
}
@media screen and (max-width: 859px) {
  .vertical-socials {
    padding: 20px 31px 13px;
  }
  .vertical-socials__main-content {
    padding-top: 30px;
  }
  .vertical-socials__socials-list {
    display: flex;
    flex-direction: row;
    gap: 11px;
    align-items: center;
    & > * {
      width: 42px;
      height: 42px;
    }
  }
  .vertical-socials__additional-message {
    padding-top: 32px;
  }
}
</style>
